module.exports = __webpack_public_path__ + "img/Pop-up_08.0c82db49.png";